// src/lib/constants/extplat.ts

// Facebook scopes required for live streaming
// Note: publish_to_groups was removed (deprecated in Graph API v19.0+)
export const FACEBOOK_LIVE_SCOPES = [
  'pages_read_engagement',
  'pages_manage_posts',
  'pages_show_list',
  'publish_video',
  'public_profile',
  'email',
  'business_management',
] as const;

// YouTube scopes (all required for live streaming + analytics)
export const YOUTUBE_LIVE_SCOPES = [
  'https://www.googleapis.com/auth/youtube',
  'https://www.googleapis.com/auth/youtubepartner',
  'https://www.googleapis.com/auth/youtube.readonly',
  'https://www.googleapis.com/auth/yt-analytics.readonly',
  'https://www.googleapis.com/auth/youtube.force-ssl',
] as const;

// Brand-specific IDs (centralized, referenced by ExtPlatConfig)
export const FACEBOOK_APP_IDS = {
  streamhoster: '1087030211367713',
  themediacdn: '990059768475942',
} as const;

export const YOUTUBE_CLIENT_IDS = {
  streamhoster: '3424296021-02qk4v6imsmafvubgua8o9glcdpuofvo.apps.googleusercontent.com',
  themediacdn: '1061885320906-vvju4pfqu5ddr4id69hi5m8c0vpplpjt.apps.googleusercontent.com',
} as const;

// Query keys
export const EXTPLAT_QUERY_KEYS = {
  extPlatAuths: (cId: number) => ['extPlatAuth', cId] as const,
  extPlatAuth: (cId: number, id: number) => ['extPlatAuth', cId, id] as const,
  fbLocations: (cId: number, authId: number) => ['extPlatAuth', cId, authId, 'fbLocations'] as const,
} as const;
